<template>
  <el-container class="tg-tool--wrapper">
    <tg-toolbar-btn v-if="displayMini" @click.native="showToolDialog">
      <slot name="icon"></slot>
    </tg-toolbar-btn>

    <portal
      :to="portal ? 'toolDialog' : 'tool-inner-dialog'"
      :disabled="!displayMini"
      class="col-12"
    >
      <el-container
        :direction="displayMini ? 'vertical' : 'horizontal'"
        :class="contentClass"
      >
        <slot></slot>
      </el-container>
    </portal>

    <el-dialog
      :title="title"
      width="60%"
      :visible.sync="visible"
      append-to-body
    >
      <portal-target name="tool-inner-dialog" class="inner"></portal-target>
    </el-dialog>
  </el-container>
</template>

<script>
import TgToolbarBtn from "@/components/bars/TgToolbarBtn";
export default {
  components: {
    TgToolbarBtn,
  },
  data() {
    return {
      visible: false,
    };
  },
  computed: {
    displayMini() {
      return this.isMobile || this.mini;
    },
    contentClass() {
      return [
        "tg-tool--container",
        {
          "is-mobile": this.isMobile,
        },
      ];
    },
  },
  methods: {
    showToolDialog() {
      if (!this.portal) {
        this.visible = true;
      } else {
        this.$store.dispatch("showToolDialog", { title: this.title });
      }
    },
  },
  props: {
    title: String,
    mini: Boolean,
    portal: {
      type: Boolean,
      default() {
        return true;
      },
    },
    portalToTool: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
};
</script>
